import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { PROPERTY_OWNERSHIP_API } from "../apiRoutes";
import axiosAuth from "@/services/axiosAuth";

const mutateDeletePropertyOwnership = async ({
  id,
  reason,
}: {
  id: string;
  reason: string;
}) => {
  return await axiosAuth.delete(
    `${PROPERTY_OWNERSHIP_API}/${id}?reason=${reason}`
  );
};

const useDeletePropertyOwnershipMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      reason: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeletePropertyOwnership,
    ...queryParams,
  });

export default useDeletePropertyOwnershipMutation;
